<template>
  <!-- <el-upload
    class="avatar-uploader"
    :action="url"
    :show-file-list="false"
    :data="data"
    name="photo"
    :with-credentials="true"
    :on-error="error"
    :on-success="success"
  >-->
  <el-upload class="avatar-uploader" action :show-file-list="false" :http-request="uploadLicense" :on-error="error" :on-success="success">
    <div class="up">
      <img v-if="license" :src="license" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </div>
  </el-upload>
</template>

<script>
import baseUrl from '@/api/baseUrl';
import axios from 'axios';
import qs from 'qs';

export default {
  props: {},
  data() {
    return {
      data: {
        type: 'bl_image'
      },
      type: 'bl_image',
      license: ''
    };
  },
  computed: {},
  mounted() {
    this.license = '';
  },
  // watch: {
  //   enterprise_id() {
  //     this.license = ''
  //     if (this.operationType === 'update') {
  //       this.getLicense()
  //     }
  //   }
  // },
  methods: {
    error(err, file, fileList) {
      thie.$message.error(err);
    },
    success(res, file) {
      // if (res.code === 0) {
      this.$message.success('上传成功！');
      this.license = URL.createObjectURL(file.raw);
      console.log(this.license);
      // }
    },
    async uploadLicense(param) {
      console.log(param);
      var fileObj = param.file;
      var form = new FormData();
      form.append('photo', fileObj);
      form.append('type', 'bl_image');
      // form.append('enterprise_id', this.enterprise_id)
      let res = await axios.post(baseUrl + 'api/enterprise/business/pic/add', form, {
        withCredentials: true
      });
      if (res.code === 0) {
        this.$message.success('上传成功！');
        this.license = URL.createObjectURL(fileObj);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.up {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>